import React from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import IconButtonComponent from "../Buttons/IconButton";
import SectionTypeIcon from "../Icons/SectionTypeIcon";

const CourseContentTable = ({
  weekData,
  weekIndex,
  onDragEnd,
  onEdit,
  onDelete
}) => {
  const nestedContent = weekData.content || {};

  const flattenedContent = Object.keys(nestedContent)
    .sort((a, b) => {
      const dayA = Number(a.split('-')[0]);
      const dayB = Number(b.split('-')[0]);
      return dayA - dayB;
    })
    .reduce((acc, dayKey) => {
      const dayItems = nestedContent[dayKey] || [];
      return [...acc, ...dayItems];
    }, []);

  return (
    <div style={{ overflowX: "auto" }}>
      <DragDropContext onDragEnd={(result) => onDragEnd(result, weekIndex)}>
        <table
          id={`course-content-table-${weekIndex}`}
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th style={{ padding: "6px 8px", textAlign: "left" }}>Day</th>
              <th style={{ padding: "6px 8px", textAlign: "left" }}>Title</th>
              <th style={{ padding: "6px 8px", textAlign: "center" }}>Duration (Min)</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>

          <Droppable droppableId={`droppable-week-${weekIndex}`}>
            {(provided) => {
              let lastDay = null;
              let globalIndex = 0;

              return (
                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                  {flattenedContent.map((contentItem) => {
                    const currentDay = (contentItem.day !== null && contentItem.day !== undefined)
                      ? Number(contentItem.day)
                      : null;

                    const showSeparator =
                      lastDay !== null &&
                      currentDay !== null &&
                      currentDay !== lastDay;

                    if (currentDay !== null) {
                      lastDay = currentDay;
                    }

                    const currentIndex = globalIndex;
                    globalIndex += 1;

                    const elementKey = String(
                      contentItem.id || contentItem.content_id || currentIndex
                    );

                    const cellStyle = {
                      padding: "6px 8px",
                      verticalAlign: "middle",
                    };

                    return (
                      <React.Fragment key={elementKey}>
                        {showSeparator && (
                          <tr className="dnd-no-drag">
                            <td colSpan={6} style={{ padding: "4px 0" }}>
                              <div
                                style={{
                                  borderTop: "2px dashed #831ddc",
                                  margin: "4px 0",
                                  opacity: 0.4,
                                }}
                              />
                            </td>
                          </tr>
                        )}

                        <Draggable draggableId={elementKey} index={currentIndex}>
                          {(provided, snapshot) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                ...provided.draggableProps.style,
                                backgroundColor: snapshot.isDragging
                                  ? "#f9f9f9"
                                  : "transparent",
                                display: snapshot.isDragging ? "table" : "table-row",
                                cursor: "grab",
                              }}
                            >
                              <td style={cellStyle}>
                                <span>
                                  {currentDay !== null ? currentDay : ""}
                                </span>
                              </td>
                              <td style={cellStyle}>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <SectionTypeIcon
                                    contentType={contentItem.content_type}
                                    {...(contentItem.document_name ? { fileName: contentItem.document_name } : {})}
                                  />
                                  <span>{contentItem.content}</span>
                                </div>
                              </td>
                              <td style={{ ...cellStyle, textAlign: "center" }}>
                                <span>{contentItem.duration}</span>
                              </td>
                              <td style={cellStyle}>
                                {contentItem.is_locked == "1" && (
                                  <FontAwesomeIcon icon={faLock} />
                                )}
                              </td>
                              <td style={cellStyle}>
                                <IconButtonComponent
                                  btnType={"editbtn"}
                                  onclick={(e) => {
                                    e.stopPropagation();
                                    onEdit(contentItem);
                                  }}
                                />
                              </td>
                              <td style={cellStyle}>
                                <IconButtonComponent
                                  btnType={"deleteIconbtn"}
                                  onclick={(e) => {
                                    e.stopPropagation();
                                    onDelete(contentItem);
                                  }}
                                />
                              </td>
                            </tr>
                          )}
                        </Draggable>
                      </React.Fragment>
                    );
                  })}
                  {provided.placeholder}
                </tbody>
              );
            }}
          </Droppable>
        </table>
      </DragDropContext>
    </div>
  );
};

export default CourseContentTable;